<div class="dashboard">
  <div class="p-grid dashboard-grid">
    <div class="p-col-12 p-lg-12">
      @if (loading) {
        <div class="loading-indicator">
          <p-progressSpinner></p-progressSpinner>
        </div>
      }
      @if (!loading) {
        <div class="ui-g card mt-4">
          <div class="ui-g-12 ui-md-12 ui-lg-12">
            <div class="engactivity">
              <div class="sbhd">Number of Engagements Requiring Action</div>
              <table>
                <tr>
                  <td class="engtdpanel">
                    Customer Ack Pending Approval<br /><span>{{
                      engagmentCount.customerAckApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Customer Survey Pending Approval<br /><span>{{
                      engagmentCount.customerSurveyApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Partner Survey Pending Approval<br /><span>{{
                      engagmentCount.partnerSurveyApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Findings Document Pending Approval<br /><span>{{
                      engagmentCount.findingsDocumentApprovalCount
                    }}</span>
                  </td>
                  <td class="engtdpanel">
                    Invoice Pending Approval<br /><span>{{
                      engagmentCount.invoiceApprovalCount
                    }}</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
